module.exports = __webpack_public_path__ + "static/media/rsz_yourname.fb4ed73c.jpg";